<div class="row">
  <div class="col px-0">
    <div class="webbtree-banner-container">
      <div class="webbtree-banner">
        <div class="container" style="padding-top: 30px;">
        <div class="row mb-5">
          <div class="col">
            <a data-testid="auto-app-talent-insights-free-trial-banner-a-1" href="https://www.webbtree.com/" target="_blank" style="text-decoration: none;">
              <img src="../../../assets/webbtree-freemium/webbtree-logo.svg" alt="" srcset="">
            </a>
          </div>
			</div>
         <div class="row sm-mobile"  style="padding-top: 70px;">
          <div class="col-md-6">
            <div class="mini-tab-container">
              <ul class="nav nav-pills mb-0" id="pills-tab" role="tablist">
                <li class="nav-item" role="presentation">
                  <button data-testid="auto-app-talent-insights-free-trial-banner-button-1" class="nav-link active" id="pills-jobdescription-tab" data-bs-toggle="pill" data-bs-target="#pills-jobdescription" type="button" role="tab" aria-controls="pills-jobdescription" aria-selected="true" (click)="onTabChange('jd')"><i class="fas fa-file-magnifying-glass"></i> Job Description</button>
                </li>
                <li class="nav-item" role="presentation">
                  <button data-testid="auto-app-talent-insights-free-trial-banner-button-2" class="nav-link" id="pills-search-tab" data-bs-toggle="pill" data-bs-target="#pills-search" type="button" role="tab" aria-controls="pills-search" aria-selected="false" (click)="onTabChange('quick')"><i class="fas fa-search"></i> Quick Search</button>
                </li>

              </ul>
              <div class="tab-content" id="pills-tabContent">
                <div class="tab-pane fade show active" id="pills-jobdescription" role="tabpanel" aria-labelledby="pills-jobdescription-tab">
                  <label class="f-14 font-weight-500 mb-2">Upload JD</label>

                  <div class="ats-upload-btn d-flex justify-content-center align-items-center mb-4">

                    <div  class="col text-left p-2" *ngIf="!isUploadedFileCorrect">
                      <div class="" >
                        <p class="font-weight-normal text-bluex mb-0">
                          <i class="fas fa-upload"></i> &nbsp;Upload your Job Description
                        </p>
                      </div>
                    </div>
                    <input data-testid="auto-app-talent-insights-free-trial-banner-input-1"  type="file" #document (change)="uploadFile($event)" *ngIf="!isUploadedFileCorrect"
                      accept=".doc,.docx,.txt,.pdf, .dot,.rtf,.odt,.htm,.html">

                      <div class="text-center d-flex my-3" *ngIf="isUploadedFileCorrect">
                        <img src="../../assets/paperclip.png" style="height: 18px; width: 18px;" />
                        {{ uploadedFilename }}
                        <p class="f-14 font-weight-600 text-webbtree-green ml-2 pointer mb-0" (click)="resetFormFields()">Remove</p>
                      </div>

                  </div>
                  <div class="position-relative pt-2 mb-1">
                    <label class="f-14 font-weight-500 mb-2">Paste JD</label>

                    <textarea data-testid="auto-app-talent-insights-free-trial-banner-textarea-1" type="text" placeholder="Paste your Job Description" [(ngModel)]="enteredJobDescription"
                      class="wc-textarea wc-form-control mb-2" rows="6"></textarea>
                  </div>
                  <div class="text-center">
                     <button data-testid="auto-app-talent-insights-free-trial-banner-button-3"  class="btn-get-talent-insight" [disabled]="isFreemiumDescriptionEmpty" [ngStyle]="{'opacity': isFreemiumDescriptionEmpty ? '0.65' : '1'}" (click)="sendDatatoInsights()">Get Talent Insights</button>
                  </div>
                </div>
                <div class="tab-pane fade" id="pills-search" role="tabpanel" aria-labelledby="pills-search-tab">
                  <div class="mb-5 position-relative">
                    <label class="f-14 font-weight-500 mb-2">Job Title</label>
                    <input data-testid="auto-app-talent-insights-free-trial-banner-input-2" type="text" class="wc-form-control mb-2" placeholder="Enter a job title(s)" [formControl]="jobTitleInput"
                    (keyup.enter)="selectedItem($event,'jobtitle');$event.target.blur();"
                    (keyup)="onTypeAheadSearch($event, 'jobtitle')"
                    [matAutocomplete]="jobtitle_auto" [matChipInputFor]="jobtitle_chipList"
                   >
                    <div *ngIf="jobtitleLoader" class=" spinner-border position-absolute text-black" style="top: 30px; right: 7px;"
                      role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                    <mat-autocomplete #jobtitle_auto="matAutocomplete" (optionSelected)="selectedItem($event, 'jobtitle')">
                      <mat-option *ngFor="let jt of jobTitleList" [value]="{key: jt.value, doc_count: jt.doc_count}" [matTooltip]="jt.value | titlecase" [matTooltipClass]="{ 'ai-tooltip text-black': true }" matTooltipPosition="above">
                        <span class="d-flex align-items-center">
                          <span class="text-truncate">{{jt.value | titlecase}} </span>
                          <!-- <span class="f-12 text-9696">({{jt.doc_count}})</span> -->
                        </span>
                      </mat-option>
                    </mat-autocomplete>
                    <mat-chip-grid #jobtitle_chipList>
                      <mat-chip-row class="mr-2 my-1 rightsideclose text-truncate green-chip"
                        *ngFor="let jobtitle of jobTitleSelectedList" >

                        <span class="trim-chip text-truncate hoverable-element f-12 d-flex align-items-center">
                          <span class="mx-1">{{jobtitle.chipkey | titlecase}}</span>
                        </span>
                        <span (click)="removeChip(jobtitle, 'jobtitle')">
                          <i class="far fa-times f-12" style="margin-left: 5px;" ></i>
                        </span>


                      </mat-chip-row>
                    </mat-chip-grid>
                  </div>
                    <div class="mb-5 position-relative">
                      <label class="f-14 font-weight-500 mb-2">Skills</label>

                    <input data-testid="auto-app-talent-insights-free-trial-banner-input-3" type="text" class="wc-form-control mb-2" placeholder="Enter a skill(s)" [formControl]="skillInput"
                    (keyup.enter)="selectedItem($event,'skill');$event.target.blur();"
                    (keyup)="onTypeAheadSearch($event, 'skill')"
                    [matAutocomplete]="skill_auto" [matChipInputFor]="skill_chipList"
                    >
                    <div *ngIf="skillsLoader" class=" spinner-border position-absolute text-black" style="top: 30px; right: 7px;"
                      role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                    <mat-autocomplete #skill_auto="matAutocomplete" (optionSelected)="selectedItem($event, 'skill')">
                      <mat-option *ngFor="let st of skillTitleList" [value]="{key: st.value, doc_count: st.doc_count}" [matTooltip]="st.value | titlecase" >
                        <span class="d-flex align-items-center">
                          <span class="text-truncate">{{st.value | titlecase}} </span>
                          <!-- <span class="f-12 text-9696">({{jt.doc_count}})</span> -->
                        </span>
                      </mat-option>
                    </mat-autocomplete>
                    <mat-chip-grid #skill_chipList>
                      <mat-chip-row class="mr-2 my-1 rightsideclose text-truncate green-chip"
                        *ngFor="let skill of skillsSelectedList" >

                        <span class="trim-chip text-truncate hoverable-element f-12 d-flex align-items-center">
                          <span class="mx-1">{{skill.chipkey | titlecase}}</span>
                        </span>
                        <span (click)="removeChip(skill, 'skill')">
                          <i class="far fa-times f-12" style="margin-left: 5px;" ></i>
                        </span>


                      </mat-chip-row>
                    </mat-chip-grid>
                  </div>

                  <div class="mb-6 position-relative">
                    <label class="f-14 font-weight-500 mb-2">Locations</label>

                    <div class="d-flex">
                    <span class="dropdown ats-dropBtn">
                      <button data-testid="auto-app-talent-insights-free-trial-banner-button-4" class="dropdown-toggle text-webbtree-green" type="button" id="userDropdownButton"
                        appDropdownToggle aria-haspopup="true" aria-expanded="false">
                        <div class="d-flex align-items-center text-truncate" [ngStyle]=" { 'width': '80px'}">
                          <i class="fas fa-earth mr-1"></i>
                          <span class="text-capitalize mr-1 text-truncate">{{showregion == 'asia' ? 'Asia': showregion == 'africa'? 'Africa': showregion == 'north america' ? 'North America': showregion == 'oceania' ? 'Oceania': 'South America'}}</span>
                          <i class="fas fa-chevron-down f-14"></i>
                        </div>
                      </button>
                      <div class="dropdown-menu"
                      aria-labelledby="userDropdownButton">
                        <div class="d-flex justify-content-between mb-3">
                            <p class="f-14 continentdropdown font-weight-500 text-black mb-0">Select Continent</p>
                            <div>
                                <span><i class="fas fa-times pointer"></i></span>
                            </div>

                        </div>
                        <div class="d-flex mb-4">
                            <div>
                                <div class="region-box mb-1  pointer"
                                    [ngClass]="{'border-blue': showregion === 'north america',  'border-gray': showregion !== 'north america'}"
                                    style="margin-right: 18px;" (click)="selectRegion('north america')">
                                    <img src="../../assets/images/north-america.png" class="img-fluid w-100" alt="">
                                </div>
                                <p class="text-black continentdropdown f-14 mb-0">North America</p>
                            </div>
                            <div>
                                <div class="region-box  mb-1 pointer"
                                    [ngClass]="{'border-blue': showregion === 'asia',  'border-gray': showregion !== 'asia'}"
                                    (click)="selectRegion('asia')">
                                    <img src="../../assets/images/asia.png" class="img-fluid w-100" alt="">
                                </div>
                                <p class="text-black continentdropdown f-14 mb-0">Asia</p>
                            </div>
                        </div>
                        <div class="d-flex mb-4">
                            <div>
                                <div class="region-box mb-1 pointer"
                                    [ngClass]="{'border-blue': showregion === 'south america', 'border-gray': showregion !== 'south america'}"
                                    style="margin-right: 18px;" (click)="selectRegion('south america')">
                                    <img src="../../assets/images/south-america.png" class="img-fluid w-100" alt="">
                                </div>
                                <p class="text-black continentdropdown f-14 mb-0">South America</p>
                            </div>
                            <div>
                                <div class="region-box border-gray mb-1"
                                    [ngClass]="{'border-blue': showregion === 'africa', 'border-gray': showregion !== 'africa'}" (click)="selectRegion('africa')">
                                    <img src="../../assets/images/africa.png" class="img-fluid w-100" alt="">
                                </div>
                                <p class="text-black continentdropdown f-14 mb-0">Africa</p>
                            </div>
                        </div>
                        <div class="d-flex">
                            <div>
                                <div class="region-box mb-1 pointer"
                                    [ngClass]="{'border-blue': showregion === 'oceania', 'border-gray': showregion !== 'oceania'}"
                                    style="margin-right: 18px;" (click)="selectRegion('oceania')">
                                    <img src="../../assets/images/oceania.png" class="img-fluid w-100" alt="">
                                </div>
                                <p class="text-black  continentdropdown f-14 mb-0">Oceania</p>
                            </div>
                        </div>
                      </div>
                    </span>
                    <input data-testid="auto-app-talent-insights-free-trial-banner-input-4" type="text" class="wc-form-control mb-2" placeholder="Enter a Location(s)" [formControl]="locationInput"
                    (keyup.enter)="selectedItem($event,'location');$event.target.blur();"
                    (keyup)="onTypeAheadSearch($event, 'location')"
                    [matAutocomplete]="location_auto" [matChipInputFor]="location_chipList"
                   >
                    <div *ngIf="locationsLoader" class=" spinner-border position-absolute text-black" style="top: 35px; right: 20px; z-index: 2;"
                      role="status">
                      <span class="sr-only">Loading...</span>
                    </div>
                    <mat-autocomplete #location_auto="matAutocomplete" (optionSelected)="selectedItem($event, 'location')">
                      <mat-option *ngFor="let lt of locationTitleList" [value]="{key: lt.value, doc_count: lt.doc_count}" [matTooltip]="lt.value | titlecase" >
                        <span class="d-flex align-items-center">
                          <span class="text-truncate">{{lt.value | titlecase}} </span>
                          <!-- <span class="f-12 text-9696">({{jt.doc_count}})</span> -->
                        </span>
                      </mat-option>
                    </mat-autocomplete>
                  </div>

                    <mat-chip-grid #location_chipList>
                      <mat-chip-row class="mr-2 my-1 rightsideclose text-truncate green-chip"
                        *ngFor="let location of locationSelectedList" >

                        <span class="trim-chip text-truncate hoverable-element f-12 d-flex align-items-center">
                          <span class="mx-1">{{location.chipkey | titlecase}}</span>
                        </span>
                        <span (click)="removeChip(location, 'location')">
                          <i class="far fa-times f-12" style="margin-left: 5px;" ></i>
                        </span>


                      </mat-chip-row>
                    </mat-chip-grid>
                  </div>
                  <div class="text-center">
                    <button data-testid="auto-app-talent-insights-free-trial-banner-button-5"  class="btn-get-talent-insight" [disabled]="isFreemiumQuickSearchEmpty" [ngStyle]="{'opacity': isFreemiumQuickSearchEmpty ? '0.65' : '1'}" (click)="sendDatatoInsights()">Get Talent Insights</button>
                 </div>
                </div>

              </div>
            </div>

            <div class="xs-slider-container">
                 <p class="f-14 font-weight-500 text-black">
                Trusted by forward-thinking teams around the world
              </p>
              <div id="container2">

                <div class="photobanner">
                  <img src="../../../assets/webbtree-freemium/CBRE.png" alt="">
                  <img src="../../../assets/webbtree-freemium/Suntory.png" alt="">
                  <img src="../../../assets/webbtree-freemium/ete-Connectivity.png" alt="">
                  <img src="../../../assets/webbtree-freemium/mimecast.png" alt="">
                  <img src="../../../assets/webbtree-freemium/entain.png" alt="">
                  <img src="../../../assets/webbtree-freemium/Applied.png" alt="">
                  <img src="../../../assets/webbtree-freemium/idea-forge.png" alt="">

                  <img src="../../../assets/webbtree-freemium/CBRE.png" alt="">
                  <img src="../../../assets/webbtree-freemium/Suntory.png" alt="">
                  <img src="../../../assets/webbtree-freemium/ete-Connectivity.png" alt="">
                  <img src="../../../assets/webbtree-freemium/mimecast.png" alt="">
                  <img src="../../../assets/webbtree-freemium/entain.png" alt="">
                  <img src="../../../assets/webbtree-freemium/Applied.png" alt="">
                  <img src="../../../assets/webbtree-freemium/idea-forge.png" alt="">

                  <img src="../../../assets/webbtree-freemium/CBRE.png" alt="">
                  <img src="../../../assets/webbtree-freemium/Suntory.png" alt="">
                  <img src="../../../assets/webbtree-freemium/ete-Connectivity.png" alt="">
                  <img src="../../../assets/webbtree-freemium/mimecast.png" alt="">
                  <img src="../../../assets/webbtree-freemium/entain.png" alt="">
                  <img src="../../../assets/webbtree-freemium/Applied.png" alt="">
                  <img src="../../../assets/webbtree-freemium/idea-forge.png" alt="">
                </div>
              </div>


            </div>
          </div>
          <div class="col-md-6">
            <div>
            <h1 class="f-36 font-weight-600 text-black mb-5" style="line-height: 1.5;">
              Elevate Your Sourcing<br> Strategy with <span class="text" style="color: #c845ab;">AI-Driven</span> <br> Insights & Intelligence
            </h1>
            <p class="f-16 mb-5 line-height-1 text-black col-md-11 px-0">Upload a JD or fill in your requirements to view your Talent Insights Report. Enhance your sourcing efforts and connect with top talent effectively</p>
             <p class="f-14 font-weight-500 text-black">
             Trusted by forward-thinking teams around the world
            </p>
            <div id="container3">
              <!-- <div class="photobanner">
                <img src="../../../assets/webbtree-freemium/CBRE.png" alt="">
                <img src="../../../assets/webbtree-freemium/Suntory.png" alt="">
                <img src="../../../assets/webbtree-freemium/ete-Connectivity.png" alt="">
                <img src="../../../assets/webbtree-freemium/mimecast.png" alt="">
                <img src="../../../assets/webbtree-freemium/entain.png" alt="">
                <img src="../../../assets/webbtree-freemium/Applied.png" alt="">
                <img src="../../../assets/webbtree-freemium/idea-forge.png" alt="">

                <img src="../../../assets/webbtree-freemium/CBRE.png" alt="">
                <img src="../../../assets/webbtree-freemium/Suntory.png" alt="">
                <img src="../../../assets/webbtree-freemium/ete-Connectivity.png" alt="">
                <img src="../../../assets/webbtree-freemium/mimecast.png" alt="">
                <img src="../../../assets/webbtree-freemium/entain.png" alt="">
                <img src="../../../assets/webbtree-freemium/Applied.png" alt="">
                <img src="../../../assets/webbtree-freemium/idea-forge.png" alt="">

                <img src="../../../assets/webbtree-freemium/CBRE.png" alt="">
                <img src="../../../assets/webbtree-freemium/Suntory.png" alt="">
                <img src="../../../assets/webbtree-freemium/ete-Connectivity.png" alt="">
                <img src="../../../assets/webbtree-freemium/mimecast.png" alt="">
                <img src="../../../assets/webbtree-freemium/entain.png" alt="">
                <img src="../../../assets/webbtree-freemium/Applied.png" alt="">
                <img src="../../../assets/webbtree-freemium/idea-forge.png" alt="">
              </div> -->
              	<div class="photobanner">
									<img src="../../../assets/webbtree-freemium/pwc.png" alt="">
									<img src="../../../assets/webbtree-freemium/new-york-life.png" alt="">
									<img src="../../../assets/webbtree-freemium/kpmg.png" alt="">
									<img src="../../../assets/webbtree-freemium/ete-Connectivity.png" alt="">
									<img src="../../../assets/webbtree-freemium/Applied.png" alt="">
									<img src="../../../assets/webbtree-freemium/authbridge.png" alt="">
									<img src="../../../assets/webbtree-freemium/simedarbyproperty.png" alt="">
									<img src="../../../assets/webbtree-freemium/entain.png" alt="">
									<img src="../../../assets/webbtree-freemium/birmont.png" alt="">
									<img src="../../../assets/webbtree-freemium/reimagine.png" alt="">
									<img src="../../../assets/webbtree-freemium/soulidify.png" alt="">
									<img src="../../../assets/webbtree-freemium/idea-forge.png" alt="">

									<img src="../../../assets/webbtree-freemium/pwc.png" alt="">
									<img src="../../../assets/webbtree-freemium/new-york-life.png" alt="">
									<img src="../../../assets/webbtree-freemium/kpmg.png" alt="">
									<img src="../../../assets/webbtree-freemium/ete-Connectivity.png" alt="">
									<img src="../../../assets/webbtree-freemium/Applied.png" alt="">
									<img src="../../../assets/webbtree-freemium/authbridge.png" alt="">
									<img src="../../../assets/webbtree-freemium/simedarbyproperty.png" alt="">
									<img src="../../../assets/webbtree-freemium/entain.png" alt="">
									<img src="../../../assets/webbtree-freemium/birmont.png" alt="">
									<img src="../../../assets/webbtree-freemium/reimagine.png" alt="">
									<img src="../../../assets/webbtree-freemium/soulidify.png" alt="">
									<img src="../../../assets/webbtree-freemium/idea-forge.png" alt="">


									<img src="../../../assets/webbtree-freemium/pwc.png" alt="">
									<img src="../../../assets/webbtree-freemium/new-york-life.png" alt="">
									<img src="../../../assets/webbtree-freemium/kpmg.png" alt="">
									<img src="../../../assets/webbtree-freemium/ete-Connectivity.png" alt="">
									<img src="../../../assets/webbtree-freemium/Applied.png" alt="">
									<img src="../../../assets/webbtree-freemium/authbridge.png" alt="">
									<img src="../../../assets/webbtree-freemium/simedarbyproperty.png" alt="">
									<img src="../../../assets/webbtree-freemium/entain.png" alt="">
									<img src="../../../assets/webbtree-freemium/birmont.png" alt="">
									<img src="../../../assets/webbtree-freemium/reimagine.png" alt="">
									<img src="../../../assets/webbtree-freemium/soulidify.png" alt="">
									<img src="../../../assets/webbtree-freemium/idea-forge.png" alt="">


									<img src="../../../assets/webbtree-freemium/pwc.png" alt="">
									<img src="../../../assets/webbtree-freemium/new-york-life.png" alt="">
									<img src="../../../assets/webbtree-freemium/kpmg.png" alt="">
									<img src="../../../assets/webbtree-freemium/ete-Connectivity.png" alt="">
									<img src="../../../assets/webbtree-freemium/Applied.png" alt="">
									<img src="../../../assets/webbtree-freemium/authbridge.png" alt="">
									<img src="../../../assets/webbtree-freemium/simedarbyproperty.png" alt="">
									<img src="../../../assets/webbtree-freemium/entain.png" alt="">
									<img src="../../../assets/webbtree-freemium/birmont.png" alt="">
									<img src="../../../assets/webbtree-freemium/reimagine.png" alt="">
									<img src="../../../assets/webbtree-freemium/soulidify.png" alt="">
									<img src="../../../assets/webbtree-freemium/idea-forge.png" alt="">

								</div>
            </div>


          </div>
          </div>
         </div>

         <div class="spacer">&nbsp;</div>
         <!-- <div class="spacer">&nbsp;</div> -->
        </div>
    </div>
    </div>

      <!-- <div class="talent-insights-load"  *ngIf="showQuickSearchLoader">
        <div class="generate_loader text-center align-items-center justify-content-between" style="height: 650px;">
          <p><i class="fa-regular fa-spinner mr-2"></i>Generating Talent Insights
          </p>
        </div>

      </div> -->

	<div class="container mt-8">
      <div class="spacer">&nbsp;</div>
					<div class="row mb-4">
			<div class="col text-center">
				<h2 class="mb-3 f-30 font-weight-600 text-black"> What Our Users Say</h2>
						<p>Hear how recruitment teams are transforming their hiring game with Webbtree.</p>
			</div>
		</div>
			<div class="row">
				<div class="col testimonyCardContainer">
					<div class="testimonyCard">
					<div class="logoHeader">
						<div class="logo">
							<img src="../../../assets/webbtree-freemium/applied1.png" alt="">
						</div>
					</div>
					<div class="d-flex flex-column justify-content-between align-items-start card-data-content">
					<div class="testimonyContent">
						<p class="text-left">We spent nearly 90 days trying to identify the right candidate for a critical leadership role. After using Webbtree Talent Discovery, the data and insights provided helped us redirect our entire hiring approach. The location-based architecture data was particularly instrumental in influencing internal decisions. Once we presented Webbtree’s insights, we identified the right candidate immediately and ultimately hired them into the role within the next 10 days — a remarkable turnaround.</p>

					</div>
					<div class="testimonyFooter">
						<div>
							<div class="profile-image">
								<img src="../../../assets/webbtree-freemium/philYob.png" alt="">
							</div>
						</div>
						<div>

							<p class="font-weight-600 mb-1 f-16">
								Phil Yob &nbsp;<a data-testid="auto-app-talent-insights-free-trial-banner-a-2" href="https://www.linkedin.com/in/philyob/" target="_blank" style="color:#007ab9;"><i class="fab fa-linkedin" aria-hidden="true"></i></a>
							</p>
							<p class="mb-3 font-weight-500 f-16">Senior Director Talent Acquisition, Applied Systems</p>
						</div>

					</div>
					</div>
					</div>

					<div class="testimonyCard">
					<div class="logoHeader">
						<div class="logo">
								<img src="../../../assets/webbtree-freemium/kpmg1.png" alt="">
						</div>
					</div>
					<div class="d-flex flex-column justify-content-between align-items-start  card-data-content">
					<div class="testimonyContent">
						<p class="text-left">
						obtain verified contact information within hours and facilitate introductions…. The Company and Market insights tool provided accurate (I double-checked) and insightful data about companies and candidates, which was incredibly valuable..The search functionality, including Boolean searches and similar profile searches, is intuitive and precise…. The tool is also cost-effective, making it a viable option in today’s budget-conscious environment</p>

					</div>
						<div class="testimonyFooter">
							<div>
							<div class="profile-image">
								<img src="../../../assets/webbtree-freemium/javeedKhan.png" alt="">
							</div>
						</div>
						<div>
							<p class="font-weight-600 mb-1 f-16">
								Javeed Khan &nbsp;<a data-testid="auto-app-talent-insights-free-trial-banner-a-3" href="https://www.linkedin.com/in/javeedashrafkhan/" target="_blank" style="color:#007ab9;"><i class="fab fa-linkedin" aria-hidden="true"></i></a>
							</p>
							<p class="mb-3 font-weight-500 f-16"> Director of Talent Acquisition, KPMG</p>
							</div>
						</div>
						</div>
					</div>

					<div class="testimonyCard">
					<div class="logoHeader">
						<div class="logo">
								<img src="../../../assets/webbtree-freemium/ideaforge1.png" alt="">
						</div>
					</div>
					<div class="d-flex flex-column justify-content-between align-items-start  card-data-content">
					<div class="testimonyContent">
					<p class="text-left"> We have been using Webbtree's ATS and collaborating closely with the team to help manage our recruitment efforts at ideaForge for over 2 years now. Webbtree team is highly customer focused and is accommodative of suggestions for tool enhancement and user experience. I highly recommend this automation platform for creating a strong talent pool and a talent acquisition system</p>

					</div>
					<div class="testimonyFooter">
						<div>
							<div class="profile-image">
								<img src="../../../assets/webbtree-freemium/nupurSeth.png" alt="">
							</div>
						</div>
						<div>
								<p class="font-weight-600 mb-1 f-16">
								Nupur Seth &nbsp;<a data-testid="auto-app-talent-insights-free-trial-banner-a-4" href="https://www.linkedin.com/in/nupur-seth-19500a15/" target="_blank" style="color:#007ab9;"><i class="fab fa-linkedin" aria-hidden="true"></i></a>
							</p>
							<p class="mb-3 font-weight-500 f-16"> Deputy General Manager, Ideaforge</p>
						</div>
					</div>
					</div>
					</div>
				</div>
			</div>
        <div class="spacer">&nbsp;</div>
		</div>
  <section class="section3 mt-8 mb-8 pb-6">
		<div class="text-center mb-8">
			<h2 class="mb-4 f-26 font-weight-600 text-black">
				Powering Precision Hiring at Scale
			</h2>
			<p class="col-md-5 mx-auto">The data that fuels your success - intelligently curated to give you an edge in sourcing and outreach.</p>
		</div>
		<div class="container-fluid py-8
		"  style="background-color: #FBFCFC;">
			<div class="container">
				<div class="row">
					<div class="col d-flex justify-content-center align-items-center">
						<div class="datacount">
							<div>
								<span>55%</span>
								<p class="f-12 font-weight-500">Reduction in Time to Hire</p>
							</div>
						</div>
						<div class="datacount">
							<div>
								<span>6x</span>
								<p class="f-12 font-weight-500">More Candidates Screened</p>
							</div>
						</div>
						<div class="datacount">
							<div>
								<span>300M+</span>
								<p class="f-12 font-weight-500">Underrepresented profiles</p>
							</div>
						</div>
						<div class="datacount">
							<div>
								<span>8.5M+</span>
								<p class="f-12 font-weight-500">Companies with Detailed insights</p>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</section>
    <div class="container" *ngIf="!showInsights && !showQuickSearchLoader">
      <div class="row mb-6 mb-2">
        <div class="col text-center">
          <h2 class="f-30 font-weight-600 text-black">Unlock Full Access with a 7-Day Free Trial</h2>
        </div>
      </div>
      <div class="row">
        <div class="col">
          <div class="d-flex flex-wrap">
            <div class="free-access-tiles bgimg1">
              <p class="mb40px">Analyze diverity insights to build inclusive teams.</p>
              <!-- <div>
                <img src="../../../assets/webbtree-freemium/Analyze-diverity-insights1.svg" class="img-fluid" alt="" srcset="">
              </div> -->
              <div class="onhover-layer">
                <button data-testid="auto-app-talent-insights-free-trial-banner-button-6" (click)="openFreeTrial('Diversity_Insights_Start_Free_Trial_Click')">
                  Start Free Trial <i class="fas fa-chevron-right"></i>
                </button>
              </div>
            </div>
            <div class="free-access-tiles bgimg2">
              <p class="mb40px">Track talent movement to source from growing or shrinking companies.</p>
              <!-- <div>
                <img src="../../../assets/webbtree-freemium/Track-talent-movement1.svg" class="img-fluid" alt="" srcset="">
              </div> -->
              <div class="onhover-layer">
                <button data-testid="auto-app-talent-insights-free-trial-banner-button-7" (click)="openFreeTrial('Talent_Movement_Start_Free_Trial_Click')">
                  Start Free Trial <i class="fas fa-chevron-right"></i>
                </button>
              </div>
            </div>
            <div class="free-access-tiles bgimg3">
                <p class="mb40px">Discover top skills and titles for high-demand roles.</p>
                <!-- <div>
                  <img src="../../../assets/webbtree-freemium/Discover-top-skills-and-titles1.svg" class="img-fluid" alt="" srcset="">
                </div> -->
                <div class="onhover-layer">
                  <button data-testid="auto-app-talent-insights-free-trial-banner-button-8" (click)="openFreeTrial('Discover_Skills_Title_Start_Free_Trial_Click')">
                    Start Free Trial <i class="fas fa-chevron-right"></i>
                  </button>
                </div>
            </div>
            <div class="free-access-tiles bgimg4">
                <p class="mb40px">Leverage seniority and nationality insights for targeted sourcing.</p>
                <!-- <div>
                  <img src="../../../assets/webbtree-freemium/Leverage-seniority-and-nationality-insights1.svg" class="img-fluid" alt="" srcset="">
                </div> -->
                <div class="onhover-layer">
                  <button data-testid="auto-app-talent-insights-free-trial-banner-button-9" (click)="openFreeTrial('Leverage_Seniority_Nationality_Start_Free_Trial_Click')">
                    Start Free Trial <i class="fas fa-chevron-right"></i>
                  </button>
                </div>
            </div>
            <div class="free-access-tiles bgimg5">
                <p class="mb40px">Target candidates using company talent flow and attrition trends.</p>
                <!-- <div>
                  <img src="../../../assets/webbtree-freemium/Target-candidates1.svg" class="img-fluid" alt="" srcset="">
                </div> -->
                <div class="onhover-layer">
                  <button data-testid="auto-app-talent-insights-free-trial-banner-button-10" (click)="openFreeTrial('Talent_Flow_Attrition_Start_Free_Trial_Click')">
                    Start Free Trial <i class="fas fa-chevron-right"></i>
                  </button>
                </div>
            </div>
            <div class="free-access-tiles bgimg6">
                <p class="mb40px">Access 610M+ profiles with contact information for outreach.</p>
                <!-- <div>
                  <img src="../../../assets/webbtree-freemium/Access-profiles-with-contact1.svg" class="img-fluid" alt="" srcset="">
                </div> -->
                <div class="onhover-layer">
                  <button data-testid="auto-app-talent-insights-free-trial-banner-button-11" (click)="openFreeTrial('Contact_Information_Outreach_Start_Free_Trial_Click')">
                    Start Free Trial <i class="fas fa-chevron-right"></i>
                  </button>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="spacer xs-min-height">&nbsp;</div>
    <ng-template #container id="insightsProfile">
      <div #contentRef >
        <app-insights-profile-section [tabname]="tabName"></app-insights-profile-section>

      </div>
    </ng-template>
    <!-- <div class="spacer xs-min-height">&nbsp;</div> -->
    <div #contentUpgrade style="margin-top: 30px;">
      <app-talent-insights-free-trial-form></app-talent-insights-free-trial-form>
    </div>
    <div class="spacer">&nbsp;</div>
  </div>
</div>

<!-- <app-webbtree-footer></app-webbtree-footer> -->
